import GenericModal from './GenericModal'

export default GenericModal
